import { Input, KeyCode } from "../../../lib/Input";
import Vector2 from "../../../math/Vector2";
import Ability from "../../Ability";
import Player from "../../Player";

export default class DecoyDrone extends Ability {
    blinkSpot: Vector2|undefined;

    constructor(player: Player) {
        super(player, {
            cooldown: 20,
            duration: 6,
            energyCost: 30,
            icon: 11,
            trigger: KeyCode.Digit3,
            triggerType: Input.GetKeyDown,
            info: `Phase Shift (20s cooldown) - Create a rift that you can teleport back to for 6 seconds by pressing the ability key again.`
        })
    }

    onDurationEnd(): void {
        if (!this.blinkSpot) return;

        this.player.transform.position = this.blinkSpot;
        this.player.velocity = Vector2.zero;
        this.blinkSpot = undefined;
    }

    onUseDuringDuration(): void {
        this.onDurationEnd();
        this.durationTimer = 0;
    }

    onUse(): void {
        this.blinkSpot = this.player.transform.position;
    }

    onDraw(): void {
        if (this.blinkSpot) {
            this.player.engine.StrokeCircle(this.blinkSpot, this.player.size);
        }
    }
}